module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7e1tya/tc-custom/9781439677926.jpg?1738410288343",
      "alt": "This image is the cover for the book Ghostly Tales of Lake Tahoe"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ghostly Tales of Lake Tahoe\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Ghost stories from America's \"Jewel of the Sierras\" have never been so creepy, fun, and full of mystery! "), _c('br'), _vm._v(" Welcome to the spooky shores of Lake Tahoe! "), _c('br'), _vm._v(" Stay alert! Ghosts lurk around every corner. Even the most unexpected places might be haunted by wandering phantoms. "), _c('br'), _vm._v(" Did you know Tahoe has a lake monster named Tessie? Or a prehistoric flying beast roaming the skies? Can you believe you might bump into ghostly legends like Frank Sinatra and Marilyn Monroe--and even Elvis!--just hanging around your hotel? "), _c('br'), _vm._v(" Pulled right from history, these ghostly tales will change the way you see Lake Tahoe, and have you sleeping with the light on!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kate Byrne\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("KATE BYRNE   grew up listening to stories about banshees, fairies, and ghosts in grand Irish houses. She loves hearing and telling spooky, supernatural stories and is always on the lookout for a good haunted house, a ghostly graveyard, and shape-shifting creatures.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0